export default "__VITE_ASSET__CGcqD2ID__"